// extracted by mini-css-extract-plugin
module.exports = {"pintxo-card":"Card_pintxo-card__DO5je"};